export default __webpack_public_path__ + "static/media/currency.a015b730.svg";